import { convertObjectKeysToSnakeCase } from "@/utils/converts";
import { formatDate } from "@/utils/formatting";
import { faker } from "@faker-js/faker";

export default {
  state: {
    patient: {},
    address: {},
    updatePatient: false,
    patientsFilters: {},
  },

  getters: {
    getPatientData(state) {
      return state.patient;
    },

    getPatientAddress(state) {
      return state.address;
    },

    getPatientCrudType(state) {
      return state.updatePatient;
    },

    getPatientsFilters: (state) => state.patientsFilters,
  },

  mutations: {
    setPatientData(state, data) {
      const isUpdate = Object.keys(data).length > 0;

      if (isUpdate) {
        data = convertObjectKeysToSnakeCase(data);
      }

      const payload = {
        // DADOS PESSOAIS
        id: isUpdate ? data.id : "",
        name: isUpdate ? data.name : "",
        socialName: isUpdate ? data.social_name : "",
        sexId: isUpdate ? parseInt(data.sex_id) : "",
        gender_identity_id:
          isUpdate && data.gender_identity_id
            ? parseInt(data.gender_identity_id)
            : "",
        colorId: isUpdate ? parseInt(data.color_id) : "",
        ethnicityId: isUpdate ? parseInt(data.ethnicity_id) : "",
        civilStatusId: isUpdate ? parseInt(data.civil_status_id) : "",
        motherName: isUpdate ? data.mother_name : "",
        fatherName: isUpdate ? data.father_name : "",
        birthDate: isUpdate ? formatDate(data.birth_date) : "",
        nationalityId: isUpdate ? parseInt(data.nationality_id) : "",
        birthplacesId: isUpdate ? parseInt(data.birthplaces_id) : "",
        degreeInstructionId: isUpdate
          ? parseInt(data.degree_instruction_id)
          : "",
        occupationId: isUpdate ? parseInt(data.occupation_id) : "",
        email: isUpdate ? data.email : "",
        dddHomePhone: isUpdate ? data.ddd_home_phone : "",
        homePhone: isUpdate ? data.home_phone : "",
        dddMessagePhone: isUpdate ? data.ddd_message_phone : "",
        messagePhone: isUpdate ? data.message_phone : "",
        dddCellPhone: isUpdate ? data.ddd_cell_phone : "",
        cellPhone: isUpdate ? data.cell_phone : "",
        flagNaturalness: isUpdate ? parseInt(data.flag_naturalness) : false,
        brazilEntryDate: isUpdate ? formatDate(data.brazil_entry_date) : "",
        dateNaturalness: isUpdate ? formatDate(data.date_naturalness) : "",
        naturalizationOrdinance: isUpdate ? data.naturalization_ordinance : "",

        // ENDEREÇOS
        address: isUpdate ? data.addresses : [],

        // DOCUMENTOS
        rg: isUpdate ? data.rg : "",
        issuingAuthoritiesId: isUpdate
          ? parseInt(data.issuing_authorities_id)
          : "",
        issuingUf: isUpdate ? data.issuing_uf : "",
        dataIssuing: isUpdate ? formatDate(data.data_issuing) : "",
        cpf: isUpdate ? data.cpf : "",
        cns: isUpdate ? data.cns : "",
        cnsMother: isUpdate ? data.cns_mother : "",
        flagDocumentsSubmitted: isUpdate
          ? data.flag_documents_submitted
          : false,

        // CERTIDÃO
        typeCertificateId: isUpdate ? parseInt(data.type_certificate_id) : "",
        dateCertificateIssued: isUpdate
          ? formatDate(data.date_certificate_issued)
          : "",
        registrationCertificate: isUpdate ? data.registration_certificate : "",
        registryName: isUpdate ? data.registry_name : "",
        bookNumber: isUpdate ? data.book_number : "",
        sheetNumber: isUpdate ? data.sheet_number : "",
        termNumber: isUpdate ? data.term_number : "",
        numberDeclarationBornAlive: isUpdate
          ? data.number_declaration_born_alive
          : "",

        // OBESERVAÇÃO
        observation: isUpdate ? data.observation : "",

        // DECISÃO JUDICIAL
        isJudicial: isUpdate ? data.is_judicial : "",
      };

      state.patient = payload;
      state.updatePatient = isUpdate;
    },

    setPatientAddress(state, data) {
      const address = {
        zip_code: "",
        type_addresses_id: "",
        number: "",
        public_place: "",
        neighborhood: "",
        complement: "",
        flag_correspondence: false,
        district: "",
        locality: "",
        uf: "",
        ibge: "",
        uuid: faker.string.uuid(),
      };

      state.address = Object.assign(address, data);
    },

    setPatientsFilters(state, filters) {
      state.patientsFilters = filters;
    },
  },

  actions: {
    changePatientData(context, data) {
      context.commit("setPatientData", data);
    },

    changePatientAddress(context, data) {
      context.commit("setPatientAddress", data);
    },

    changePatientsFilters(context, filters) {
      context.commit("setPatientsFilters", filters);
    },
  },
};
